// extracted by mini-css-extract-plugin
export default {"Filter_0":"filter-bar-module__Filter_0--v8FnK"};